import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import styles from "../styles/Perfiles.module.css";
import { IoPersonAdd, IoArrowBack, IoTrashOutline, IoPencil } from "react-icons/io5";

import AñadirPerfil from "./AñadirPerfil";
import ConfirmDeleteModal from "../../../components/ConfirmDeleteModal";
import InfoModal from "../../../components/InfoModal";
import PersonaList from "../../../components/PersonaList";

import ViewDocButton from "../components/ViewDocButton";
import { toSpanishDate } from "../domain/dateFormat";
import { usePerfiles } from "../hooks/usePerfiles";

const Perfiles = () => {
  const { id: personaIdFromRoute } = useParams();
  const navigate = useNavigate();
  const {
    personas,
    error,
    selectedPersona,

    showAddPersona,
    isEditing,
    personaEditId,
    showConfirm,
    infoModal,
    refreshKey,
    showImageModal,

    setSelectedPersona,
    setShowAddPersona,
    setShowConfirm,
    setInfoModal,
    setShowImageModal,

    handleEditarClick,
    handleCerrarFormulario,
    handleEliminarPersona,
    onPersonaCreada,
    toggleBajaActiva,
  } = usePerfiles(personaIdFromRoute);

  // Si llegamos aquí por una URL directa (ej. /perfiles/:id desde el calendario),
  // "Salir" nos devuelve a la pantalla anterior; si no, solo cierra el formulario.
  const handleSalirEdicion = () => {
    if (personaIdFromRoute) {
      navigate(-1);
    } else {
      handleCerrarFormulario();
    }
  };

  return (
    <div className={styles["perfiles-container"]}>
      <div className={styles["perfiles-header-global"]}>
        <h1>Perfiles</h1>

        {!isEditing && (
          <button
            className={styles["add-button-global"]}
            onClick={() => setShowAddPersona((v) => !v)}
          >
            {showAddPersona ? (
              <>
                <IoArrowBack style={{ fontSize: "20px" }} /> {"Volver"}
              </>
            ) : (
              <>
                <IoPersonAdd style={{ fontSize: "20px" }} /> {"Añadir Perfil"}
              </>
            )}
          </button>
        )}

        {isEditing && (
          <button className={styles["add-button-global"]} onClick={handleSalirEdicion}>
            <IoArrowBack style={{ fontSize: "20px" }} /> {"Salir"}
          </button>
        )}
      </div>

      {error ? (
        <p style={{ color: "red", fontWeight: "bold", textAlign: "center", marginTop: "50px" }}>
          {error}
        </p>
      ) : personas.length === 0 && !showAddPersona && !isEditing ? (
        <p style={{ textAlign: "center", marginTop: "50px" }}>No hay personas registradas.</p>
      ) : (
        <div className={styles["perfiles-columns-wrapper"]}>
          <div className={styles["perfil-detalle-area"]}>
            {showAddPersona && !isEditing ? (
              <AñadirPerfil onPersonaCreada={onPersonaCreada} />
            ) : isEditing && personaEditId ? (
              <AñadirPerfil personaId={personaEditId} onPersonaCreada={(p) => handleCerrarFormulario(p)} />
            ) : (
              selectedPersona && (
                <div className={styles["perfil-box"]}>
                  <div className={styles["perfil-acciones"]}>
                    <div className={styles["botones-acciones"]}>
                      <button
                        className={`${styles["add-button-global"]} ${styles["eliminar-boton"]}`}
                        onClick={() => setShowConfirm(true)}
                      >
                        <IoTrashOutline size={20} /> Eliminar
                      </button>

                      <button
                        className={styles["add-button-global"]}
                        style={{ marginLeft: 8 }}
                        onClick={toggleBajaActiva}
                      >
                        {selectedPersona.estado === "BAJA" ? "Reactivar" : "Dar de baja"}
                      </button>
                    </div>

                    <button
                      className={`${styles["add-button-global"]} ${styles["editar-boton"]}`}
                      onClick={() => handleEditarClick(selectedPersona.id)}
                    >
                      <IoPencil size={20} /> Editar
                    </button>
                  </div>

                  <div className={styles["perfil-identidad"]}>
                    {selectedPersona.foto ? (
                      <img
                        className={styles["avatar-circle"]}
                        src={selectedPersona.foto}
                        alt={`${selectedPersona.nombre} ${selectedPersona.apellidos}`}
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowImageModal(true)}
                      />
                    ) : (
                      <div className={styles["avatar-circle"]}>
                        <span>
                          {selectedPersona.nombre?.charAt(0) || "?"}
                          {selectedPersona.apellidos?.charAt(0) || "?"}
                        </span>
                      </div>
                    )}

                    <span
                      className={`${styles.pill} ${selectedPersona.estado === "BAJA" ? styles["pill-baja"] : styles["pill-activa"]
                        }`}
                      style={{ marginLeft: 8 }}
                    >
                      Estado de la cuenta: {selectedPersona.estado || "ACTIVA"}
                    </span>
                  </div>

                  <div className={styles["perfil-info"]}>
                    <div className={styles["info-bloque"]}>
                      <div className={styles["info-header"]}>
                        <strong>Datos Personales</strong>
                      </div>
                      <div className={styles["info-grid"]}>
                        <p>Tratamiento: <strong>{selectedPersona.tratamiento || "—"}</strong></p>
                        <p>Nombre: <strong>{selectedPersona?.nombre || "—"}</strong></p>
                        <p>Nombre 2: <strong>{selectedPersona.nombre2 || "—"}</strong></p>
                        <p>Apellidos: <strong>{selectedPersona.apellidos || "—"}</strong></p>
                        <p>Nickname: <strong>{selectedPersona.nickname || "—"}</strong></p>
                        <p>Email: <strong>{selectedPersona.email || "—"}</strong></p>
                        <p>Teléfono: <strong>{selectedPersona.telefono || "—"}</strong></p>
                        <p>Dirección: <strong>{selectedPersona.direccion || "—"}</strong></p>
                        <p>País: <strong>{selectedPersona.pais || "—"}</strong></p>
                        <p>Provincia: <strong>{selectedPersona.provincia || "—"}</strong></p>
                        <p>Código Postal: <strong>{selectedPersona.codigoPostal || "—"}</strong></p>
                      </div>
                    </div>

                    <div className={styles["info-bloque"]}>
                      <div className={styles["info-header"]}>
                        <strong>Persona de Contacto</strong>
                      </div>
                      <div className={styles["info-grid"]}>
                        <p>Nombre: <strong>{selectedPersona.contacto || "—"}</strong></p>
                        <p>Email: <strong>{selectedPersona.emailContacto || "—"}</strong></p>
                        <p>Teléfono: <strong>{selectedPersona.telefonoContacto || "—"}</strong></p>
                      </div>
                    </div>

                    <div className={styles["info-bloque"]}>
                      <div className={styles["info-header"]}>
                        <strong>Alergenos</strong>
                      </div>

                      {selectedPersona.alergenos?.length > 0 ? (
                        <div className={styles["info-grid"]}>
                          {selectedPersona.alergenos.map((alergeno, index) => (
                            <p key={index}>
                              <strong>{alergeno.alergenoDescripcion || alergeno.alergeno || alergeno.nombre}</strong>
                            </p>
                          ))}
                        </div>
                      ) : (
                        <strong><p>Ninguna alergia registrada.</p></strong>
                      )}
                    </div>

                    <div className={styles["info-bloque"]}>
                      <div className={styles["info-header"]}>
                        <strong>Documentación</strong>
                      </div>
                      <div className={styles["info-grid"]}>
                        <p>Tipo Documento: <strong>{selectedPersona.tipoDocumentoDescripcion || "—"}</strong></p>
                        <p>Número Documento: <strong>{selectedPersona.numeroDocumento || "—"}</strong></p>
                        <p>
                          Fecha de Caducidad:{" "}
                          <strong>{toSpanishDate(selectedPersona.fechaCaducidad?.slice(0, 10)) || "—"}</strong>
                        </p>
                        <p>
                          Documento identidad:{" "}
                          <strong><ViewDocButton url={selectedPersona.imagenDocumento} /></strong>
                        </p>
                      </div>
                    </div>


                    <div className={styles["info-bloque"]}>
                      <div className={styles["info-header"]}>
                        <strong>Licencias de Armas</strong>
                      </div>

                      {selectedPersona.licenciasArmas?.length > 0 ? (
                        <>
                          {selectedPersona.licenciasArmas.map((licencia, index) => (
                            <div key={index} className={`${styles["info-grid"]} ${styles.bordered}`}>
                              <p>Tipo: <strong>{licencia.tipoDescripcion || "—"}</strong></p>
                              <p>País: <strong>{licencia.pais || "—"}</strong></p>
                              <p>Fecha de Expedición: <strong>{toSpanishDate(licencia.fechaDeExpedicion) || "—"}</strong></p>
                              <p>Fecha de Validez: <strong>{toSpanishDate(licencia.fechaValidez) || "—"}</strong></p>
                            </div>
                          ))}

                          <p>
                            Documento:{" "}
                            <strong><ViewDocButton url={selectedPersona.licenciaArmasRutaDocumento} /></strong>
                          </p>
                        </>
                      ) : (
                        <div className={styles["info-grid"]}>
                          <p><strong>Sin licencias de armas registradas.</strong></p>
                        </div>
                      )}
                    </div>



                    <div className={styles["info-bloque"]}>
                      <div className={styles["info-header"]}>
                        <strong>Licencia de Caza</strong>
                      </div>

                      {selectedPersona.licenciasCaza?.length > 0 ? (
                        <div className={styles["info-grid"]}>
                          <p>Número: <strong>{selectedPersona.licenciasCaza[0]?.numero || "—"}</strong></p>
                          <p>
                            Fecha de Expedición:{" "}
                            <strong>{toSpanishDate(selectedPersona.licenciasCaza[0]?.fechaDeExpedicion) || "—"}</strong>
                          </p>
                          <p>
                            Documento:{" "}
                            <strong><ViewDocButton url={selectedPersona.licenciasCaza[0]?.rutaDocumento} /></strong>
                          </p>
                          <p>
                            Fecha de Caducidad:{" "}
                            <strong>
                              {selectedPersona.licenciasCaza[0]?.fechaIndefinida
                                ? "Indefinida"
                                : toSpanishDate(selectedPersona.licenciasCaza[0]?.fechaCaducidad) || "—"}
                            </strong>
                          </p>
                        </div>
                      ) : (
                        <div className={styles["info-grid"]}>
                          <p><strong>Sin licencia de caza registrada.</strong></p>
                        </div>
                      )}
                    </div>

                    <div className={styles["info-bloque"]}>
                      <div className={styles["info-header"]}>
                        <strong>Seguro</strong>
                      </div>

                      {selectedPersona.seguros?.length > 0 ? (
                        <div className={styles["info-grid"]}>
                          <p>
                            Fecha de Caducidad:{" "}
                            <strong>{toSpanishDate(selectedPersona.seguros[0]?.fechaDeCaducidad) || "—"}</strong>
                          </p>
                          <p>
                            Documento:{" "}
                            <strong>
                              <ViewDocButton url={selectedPersona.seguros[0]?.rutaDocumento} />
                            </strong>
                          </p>
                        </div>
                      ) : (
                        <div className={styles["info-grid"]}>
                          <p><strong>Sin seguro registrado.</strong></p>
                        </div>
                      )}
                    </div>




                    <div className={styles["info-bloque"]}>
                      <div className={styles["info-header"]}>
                        <strong>Armas</strong>
                      </div>

                      {selectedPersona.armas?.length > 0 ? (
                        selectedPersona.armas.map((arma, index) => (
                          <div key={index} className={`${styles["info-grid"]} ${styles.bordered}`}>
                            <p>Modelo: <strong>{arma.modelo || "—"}</strong></p>
                            <p>Marca: <strong>{arma.marca || "—"}</strong></p>
                            <p>País: <strong>{arma.pais || "—"}</strong></p>
                            <p>Nº Guía: <strong>{arma.numeroGuia || "—"}</strong></p>
                            <p>Nº Serie: <strong>{arma.numeroSerie || "—"}</strong></p>
                            <p>Calibre: <strong>{arma.calibreDescripcion || "—"}</strong></p>
                            <p>Tipo de Arma: <strong>{arma.tipoArmaDescripcion || "—"}</strong></p>
                            <p>Licencia de Armas (Titular): <strong>{arma.proximaReparacion || "—"}</strong></p>
                            <p>
                              Guía de arma:{" "}
                              <strong><ViewDocButton url={arma.rutaDocumentoGuiaArma} label="Ver guía" /></strong>
                            </p>
                          </div>
                        ))
                      ) : (
                        <div className={styles["info-grid"]}>
                          <p><strong>Sin armas registradas.</strong></p>
                        </div>
                      )}
                    </div>


                    <div className={styles["info-bloque"]}>
                      <div className={styles["info-header"]}>
                        <strong>Comentarios</strong>
                      </div>
                      <div className={styles["info-grid"]}>
                        <p>{selectedPersona.comentarios || "—"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>

          <div className={styles["perfiles-sidebar-right"]}>
            <PersonaList
              onSelectPersona={(persona) => setSelectedPersona(persona)}
              selectedPersona={selectedPersona}
              refreshKey={refreshKey}
            />
          </div>
        </div>
      )}

      {showImageModal && selectedPersona?.foto && (
        <div className={styles["image-modal-overlay"]} onClick={() => setShowImageModal(false)}>
          <div className={styles["image-modal-content"]} onClick={(e) => e.stopPropagation()}>
            <img src={selectedPersona.foto} alt="Foto ampliada" />
            <button className={styles["close-button"]} onClick={() => setShowImageModal(false)}>
              ✖
            </button>
          </div>
        </div>
      )}

      {showConfirm && (
        <ConfirmDeleteModal
          title="Confirmar Eliminación"
          message={`¿Estás seguro de que deseas eliminar a ${selectedPersona?.nombre} ${selectedPersona?.apellidos}? Esta acción no se puede deshacer.`}
          confirmWord="Eliminar"
          onClose={() => setShowConfirm(false)}
          onConfirm={handleEliminarPersona}
        />
      )}

      {infoModal.open && (
        <InfoModal
          title={infoModal.title}
          message={infoModal.message}
          onClose={() => setInfoModal({ open: false, title: "", message: "" })}
        />
      )}
    </div>
  );
};

export default Perfiles;
